import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14 6.667h-3.333v-2A.666.666 0 0 0 10 4H2.667V2a.667.667 0 0 0-1.334 0v12a.666.666 0 1 0 1.334 0v-2H14a.667.667 0 0 0 .667-.667v-4A.666.666 0 0 0 14 6.667M2.667 5.333h6.666v1.334H2.667zm10.666 5.334H2.667V8h10.666z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })